import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";
import { getQueryKey } from "@trpc/react-query";

// The function this hook returns can be used to invalidate the authentications query and refetch it, which is
// necessary when a new connection is created or an existing connection is reconnected.

export const useRefetchAuthentications = () => {
  const queryClient = useQueryClient();
  const authenticationsKey = getQueryKey(
    trpc.authentication.authentications,
    undefined,
    "any",
  );
  const connectionStatsKey = getQueryKey(
    trpc.authentication.connectionStats,
    undefined,
    "any",
  );

  const refetchAuthentications = () => {
    queryClient.cancelQueries({ queryKey: authenticationsKey });
    queryClient.invalidateQueries({
      queryKey: authenticationsKey,
      refetchType: "all",
    });
    queryClient.invalidateQueries({ queryKey: connectionStatsKey });
  };

  return { refetchAuthentications };
};
